import destroy from './destroy';
import store from './store';
import show from './show';
import update from './update';
import all from './all';
import items from './items';
import downloadProduct from './downloadProduct';
import updateDraft from './updateDraft';
import saveDraft from './saveDraft';
import adjustmentType from './adjustmentType';

export default {
  destroy,
  store,
  show,
  update,
  all,
  items,
  downloadProduct,
  updateDraft,
  saveDraft,
  adjustmentType,
};



// WEBPACK FOOTER //
// ./src/app/services/adjustment/index.js